import { render } from "./VendorNotificationDialog.vue?vue&type=template&id=6b00f4b6&scoped=true"
import script from "./VendorNotificationDialog.vue?vue&type=script&lang=js"
export * from "./VendorNotificationDialog.vue?vue&type=script&lang=js"

import "./VendorNotificationDialog.vue?vue&type=style&index=0&id=6b00f4b6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b00f4b6"]])

export default __exports__